import api from './'

export default {

    /**
     * Upload media
     * @param data
     */
    upload(data) {
        return api
            .post(`/medias`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Upload media to specific drive
     * @param drive
     * @param data
     */
    uploadToDrive(drive, data) {
        return api
            .post(`/medias/${drive}`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get medias
     * @param params
     */
    get(params) {
        return api
            .get(`/medias`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Show media
     * @param mediaId
     */
    show(mediaId, params) {
        return api
            .get(`/medias/${mediaId}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Delete media
     * @param mediaId
     */
    delete(mediaId) {
        return api
            .delete(`/medias/${mediaId}`)
            .then(response => {
                return response.data
            })
    },

    /**
     * Change the order of a group of medias
     * @param data
     */
    updateGallery(data) {
        return api
            .put(`/medias/order`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get invoice annotation
     * @param mediaId
     * @param params
     */
    getInvoiceAnnotation(mediaId, params) {
        return api
            .get(`/medias/${mediaId}/getInvoiceAnnotation`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    }

}
